import { Box, Text } from 'ink';
import { ComponentProps } from 'react';

export default function CustomSelectInputItem({
  isSelected,
  label,
  ...props
}: {
  isSelected?: boolean;
  label: string;
} & ComponentProps<typeof Box>) {
  return (
    <Text bold={isSelected} color={isSelected ? undefined : 'gray'} {...props}>
      {label}
    </Text>
  );
}
